export const CUSTOMERS_MODALS = {
  createModal: 'createModal',
  deleteModal: 'deleteModal',
  kwpCustomers: 'kwpCustomers',
};
